export function PhoneNumberFilter() {
    return function(phone) {
        if(!phone) return;
        var value = phone.toString().trim().replace(/^\+/, '');

        if(value.match(/^\d{10, 11}$/)) {
            return phone;
        }

        let country, city, number;
        switch(value.length) {
        case 10:
            country = '';
            city = value.slice(0, 3);
            number = value.slice(3);
            break;
        case 11:
            country = value[0];
            city = value.slice(1, 4);
            number = value.slice(4);
            break;
        default:
            return phone;
        }

        return `${country} (${city}) ${number.slice(0, 3)}-${number.slice(3)}`.trim();
    };
}
